import { MARQUEE } from "@/data/content";
import { Star } from "./Reveal";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((m) => (
      <span key={m} className="flex items-center">
        <span className="font-display whitespace-nowrap px-6 text-3xl font-extrabold text-[var(--ink)] sm:text-5xl">{m}</span>
        <Star className="h-8 w-8 sm:h-10 sm:w-10" fill="var(--red)" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative z-10 -my-6 -rotate-2 overflow-hidden border-y-4 border-white bg-[var(--yellow)] py-4 shadow-[0_20px_40px_-20px_rgba(27,27,51,0.4)]" data-testid="brand-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
